export default "__VITE_ASSET__DOUxMYNr__"